module.exports = __webpack_public_path__ + "img/0-29.28793097.jpg";